import {Fragment} from "react";
import {Paper} from "@mui/material";
import {TableComponent} from "../TableCheckComponent";

const columsDefault = [
        // { headerName: '#', field: 'id', flex: 0 },
        { headerName: 'Fecha de Creacion', field: 'fecha_creada'},
        { headerName: 'Unidad', field: 'nombre'},
        { headerName: 'Posicion 1', field: 'P1'},
        { headerName: 'Milimetros 1', field: 'M1'},
        { headerName: 'Posicion 2', field: 'P2'},
        { headerName: 'Milimetros 2', field: 'M2'},
        { headerName: 'Posicion 3', field: 'P3'},
        { headerName: 'Milimetros 3', field: 'M3'},
        { headerName: 'Posicion 4', field: 'P4'},
        { headerName: 'Milimetros 4', field: 'M4'},
        { headerName: 'Posicion 5', field: 'P5'},
        { headerName: 'Milimetros 5', field: 'M5'},
        { headerName: 'Posicion 6', field: 'P6'},
        { headerName: 'Milimetros 6', field: 'M6'},
        { headerName: 'Aceite', field: 'aceite'},
        { headerName: 'Direccion', field: 'direccion'},
        { headerName: 'Refrigerante', field: 'refrigerante'},
        { headerName: 'Clutch', field: 'clutch'},
        { headerName: 'Reporte', field: 'reporte'},
 ];

export function UnitNoCheckComponent({dataNoCheck=[]}){

    return(
        <Fragment>
            <Paper >

                <TableComponent
                    columnsTable={columsDefault}
                    rowsTable={dataNoCheck}
                />

            </Paper>
        </Fragment>
    );

}